<template>
  <div>
    <v-btn dark color="red" fixed icon
      style="z-index:10;left:100px;top:22px;opacity:0.8; width:56px;height:56px"
      @click="goBack(reportData.containedBy)"
    >
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-speed-dial
      class="strategio-report-speed-dial"
      :style="fab ? 'opacity: 1' : 'opacity: 0.5'"
      v-model="fab"
      top left direction="bottom"
      transition="slide-y-transition"
      v-intro="'Desde aquí podrá marcar este reporte como favorito, ver la lista de reportes disponibles o regresar a la página de reportes'"
    >
      <v-btn
        slot="activator"
        color="blue"
        dark
        fab
        hover
        v-model="fab"
      >
        <v-icon>add</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <!-- <v-btn fab dark small color="red" @click="goBack(reportData.containedBy)">
        <v-icon>arrow_back</v-icon>
      </v-btn> -->
      <v-btn fab dark small color="blue" @click="openPanel()">
        <v-icon>more_vert</v-icon>
      </v-btn>
      <v-btn v-if="reportData.url2.trim() !== ''" fab dark small color="blue" @click="download()">
        <v-icon>file_download</v-icon>
      </v-btn>
      <v-btn fab dark small :color="(reportData.isFavorite == 1) ? 'amber darken-1' : 'grey lighten-1'" @click="setFavorite(reportData)">
        <v-icon>star</v-icon>
      </v-btn>
    </v-speed-dial>

    <v-navigation-drawer v-if="!['xs', 'sm'].includes($vuetify.breakpoint.name)" right absolute light v-model="drawer" overflow temporary>
      <v-list subheader>
        <v-subheader >{{containedByFolder.itemName}}</v-subheader>
        <v-list-tile
          :class="(r.itemID == reportData.itemID) ? 'blue darken-1' : ''"
          v-for="(r, index) in reportsInFolder"
          v-bind:key="index"
          @click="goToReport(r)"
        >
          <v-list-tile-content :class="(r.itemID == reportData.itemID) ? 'grey--text text--lighten-4' : ''">
            <v-list-tile-title class="strategio-showreport-drawer-item-title">{{r.itemName}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <iframe class="strategio-iframe" :src="url" frameBorder="0"></iframe>
  </div>
</template>

<script>
import reportsStorage from '../storage/reportsStorage'

export default {
  name: 'show-report',
  data () {
    return {
      reportData: {
        url2: ''
      },
      url: '',
      fab: false,
      drawer: false,
      containedByFolder: {},
      reportsInFolder: []
    }
  },
  beforeRouteUpdate (to, from, next) {
    // react to route changes...
    // don't forget to call next()
    this.loadFolders(to.params.reportID)
    // this.reportID = to.params.reportID
    next()
  },
  mounted () {
    this.loadFolders(this.$route.params.reportID)
    // this.reportID = this.$route.params.reportID

    if (this.$route.query['main-page']) {
      console.log('main-page: ', this.$route.query['main-page'])

      let intro = this.$intro()
      intro.setOptions({
        skipLabel: 'Saltar',
        nextLabel: 'Siguiente',
        prevLabel: 'Previo',
        doneLabel: 'Listo'
      })

      intro.start().oncomplete(() => {
        this.$router.push('/0')
      })
    }
  },
  methods: {
    download () {
      reportsStorage.registerView(this.reportData.reportID, 'DOWNLOAD')
      this.url = this.reportData.url2
    },
    setFavorite (report) {
      // TODO: Enviar al servidor :D
      this.reportData.isFavorite = !this.reportData.isFavorite
      reportsStorage.setFavorite(report.itemID, this.reportData.isFavorite)
    },
    goToReport (report) {
      let _isFavorite = ''
      if (this.$route.params.isFavorite) {
        _isFavorite = '/1'
      }
      this.$router.push(`/show-report/${report.itemID}${_isFavorite}`)
    },
    goBack (containedBy) {
      if (this.$route.params.isFavorite) {
        this.$router.push('/user/favorites')
        return
      }
      this.$router.push(`/${containedBy}`)
    },
    openPanel () {
      this.drawer = !this.drawer
    },
    loadFolders (reportID) {
      reportsStorage.getData({
        folderID: '0',
        forceLoad: false,
        onSuccess: (data, store) => {
          const report = reportsStorage.findItemByID(reportID)
          this.reportData = report
          this.url = report.url1

          if (this.$route.params.isFavorite) {
            this.containedByFolder = {itemName: 'FAVORITOS'}
          } else {
            this.containedByFolder = reportsStorage.findItemByID(report.containedBy) || {itemName: 'REPORTES'}
          }

          if (this.$route.params.isFavorite) {
            const _favorites = []
            store.map((item, index) => {
              if (item.isFavorite) {
                _favorites.push(item)
              }
            })
            this.reportsInFolder = _favorites
          } else {
            this.reportsInFolder = reportsStorage.findItemsInFolder(report.containedBy, 'REPORTS')
          }
          reportsStorage.registerView(reportID, 'VIEW')
        },
        onError: (error) => {
          this.messsage = 'Error desconocido'
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data)
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request)
            this.messsage = 'No pudimos obtener respuesta del servidor'
          } else {
            // Something happened in setting up the request that triggered an Error
            this.message = `Error desconocido: ${error.message}`
          }
          this.snackbar = true
          console.log(error.config)
        }
      })
    }
  }
}
</script>

<style>
  .strategio-iframe {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .strategio-report-speed-dial {
    opacity: 0.5;
    position: absolute !important;
    z-index: 9;
  }
  .strategio-showreport-drawer-item-title {
    font-weight: 300;
    font-size: 16px;
  }
  .strategio-showreport-drawer-item-title-active {
    background-color: blue;
    color: white;
  }
</style>




// WEBPACK FOOTER //
// src/routes/show-report.vue